export const getContactInitials = (contact) => {
  let firstName = "";
  let lasName = "";

  if (contact?.first_name?.length >= 0) {
    firstName =
      contact?.first_name?.length > 0
        ? contact?.first_name?.charAt?.(0).toUpperCase?.()
        : "";
    lasName =
      contact?.last_name?.length > 0
        ? contact?.last_name?.charAt?.(0).toUpperCase?.()
        : "";
  } else {
    let contactNameList = contact?.split(" ");
    firstName = contactNameList[0]?.charAt?.(0).toUpperCase?.();
    if (contactNameList[1] !== undefined) {
      lasName = contactNameList[1]?.charAt?.(0).toUpperCase?.();
    }
  }
  return firstName?.concat?.(lasName);
};
